<template>
  <div class="baiduQueue">
    <div class="formClass">
      <!-- <div class="title">输入</div> -->
      <div class="top-title">MiReportor</div>
      <div class="top-desc">
        Medical Imaging Reportor: a computer-aided imaging report generater for
        understanding and interpreting multimodal medical images
      </div>
      <div style="display:flex;justify-content: center;">
        <div class="f2" style="">
          <el-upload
            class="upload-demo"
            drag
            action=""
            :show-file-list="false"
            :http-request="httpRequest"
            accept=".jpg,.jpeg,.png,.JPG,.PNG,.JPEG"
            :before-upload="beforeAvatarUpload"
            name="file"
            multiple
          >
            <img
              v-if="!form.img"
              class="el-icon-upload"
              src="../../../static/index2.png"
              alt=""
            />
            <div v-if="!form.img" class="el-upload__text">
              拖拽图片到此处或点击上传图片
            </div>
            <img v-if="form.img" class="showImg" :src="form.img" alt="" />
          </el-upload>
          <el-form
            class="form_right"
            ref="form"
            :rules="rules"
            :model="form"
            label-width="0"
            style=""
          >
            <el-form-item
              label="图片类别"
              prop="type"
              border
              label-position="right"
              label-width="180"
            >
              <!-- <el-radio-group v-model="form.type" size="small">
                <el-radio label="1" border>CT</el-radio>
                <el-radio label="2" border>Other</el-radio>
              </el-radio-group> -->
              <el-select
                v-model="form.type"
                placeholder="请选择"
                style="width:200px;background: linear-gradient(180deg, #FFFFFF 0%, #F9F9FB 100%);"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div
              style="width: calc(100% + 20px);height:1px;background:#dee3ec;margin-left:-10px"
            ></div>
            <el-form-item label="报告标题" prop="title" label-width="180">
              <el-input type="textarea" v-model="form.title"></el-input>
            </el-form-item>
            <div
              style="width: calc(100% + 20px);height:1px;background:#dee3ec;margin-left:-10px"
            ></div>
            <el-form-item label="选择模型" prop="model" label-width="180">
              <el-radio-group v-model="form.model" size="small">
                <!-- <el-radio label="1" border>imicams.BLIP</el-radio> -->
                <!-- <el-radio label="2" border>model2</el-radio> -->
                <el-radio label="1" border>CXR-Reportor</el-radio>
                <el-radio label="2" border>CXR-TMRGM</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item> </el-form-item> -->
          </el-form>
          <div style="display:flex;flex:1;margin-top:34px">
            <el-button
              @click="removeData"
              class="btnClass11"
              style="width:50%;background: linear-gradient(180deg, #FFFFFF 0%, #F9F9FB 100%);border: 1px solid #D7DCE4;"
              >清除</el-button
            >
            <el-button
              type="primary"
              style="background: linear-gradient(180deg, #16796F 0%, #045A51 100%);width:50%;border: 1px solid #004B43;"
              @click="submit('form')"
              >提交</el-button
            >
          </div>
        </div>

        <!-- 提交图片后输出需要修改内容 -->
        <div
          style="background: #f7f8fa;padding:20px; margin: 0 0 0 32px;width: 50%;border-radius: 12px;"
        >
          <div class="output">
            <!-- <div class="title">输出</div> -->
            <!-- <div class="o1">
          <div>{{ item.title }}</div>
          <el-image
            :src="item.image"
            :preview-src-list="[item.image]"
          ></el-image>
        </div> -->
            <div class="o2 box">
              <div class="o21 b1" style="text-align: left;">标签</div>
              <div class="o22">
                <el-tag
                  :key="tag"
                  v-for="tag in item.tagsStr"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                  {{ tag }}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button
                  v-else
                  class="button-new-tag addBtn"
                  size="small"
                  @click="showInput"
                  :disabled="item.id ? false : true"
                  >+ 添加标签</el-button
                >
              </div>
            </div>
            <div class="o3 box">
              <div class="o31 b1" style="text-align: left;">检查所见</div>
              <div class="textareaBox" :class="textUpdate1 ? '' : 'boxBorder'">
                <el-input
                  type="textarea"
                  v-model="item.overview"
                  :autosize="{ minRows: 2, maxRows: 10 }"
                  :readonly="textUpdate1"
                  :disabled="item.id ? false : true"
                ></el-input>
                <el-button
                  :disabled="item.id ? false : true"
                  type="text"
                  :icon="textUpdate1 ? 'el-icon-edit' : 'el-icon-check'"
                  @click="updateText(1, '')"
                ></el-button>
              </div>
              <div
                class="textareaBox"
                :class="textUpdate1En ? '' : 'boxBorder'"
              >
                <el-input
                  type="textarea"
                  v-model="item.overviewEn"
                  :autosize="{ minRows: 2, maxRows: 10 }"
                  :readonly="textUpdate1En"
                  :disabled="item.id ? false : true"
                ></el-input>
                <el-button
                  :disabled="item.id ? false : true"
                  type="text"
                  :icon="textUpdate1En ? 'el-icon-edit' : 'el-icon-check'"
                  @click="updateText(1, 'En')"
                ></el-button>
                <!-- {{ textUpdate1En ? "编辑" : "完成" }} -->
              </div>
            </div>
            <div class="o3 box">
              <div class="o31 b1" style="text-align: left;">检查意见</div>
              <div class="textareaBox" :class="textUpdate2 ? '' : 'boxBorder'">
                <el-input
                  type="textarea"
                  v-model="item.suggestion"
                  :autosize="{ minRows: 2, maxRows: 10 }"
                  :readonly="textUpdate2"
                  :disabled="item.id ? false : true"
                ></el-input>
                <el-button
                  :disabled="item.id ? false : true"
                  type="text"
                  :icon="textUpdate2 ? 'el-icon-edit' : 'el-icon-check'"
                  @click="updateText(2, '')"
                ></el-button>
                <!-- {{ textUpdate2 ? "编辑" : "完成" }} -->
              </div>
              <div
                class="textareaBox"
                :class="textUpdate2En ? '' : 'boxBorder'"
              >
                <el-input
                  type="textarea"
                  v-model="item.suggestionEn"
                  :autosize="{ minRows: 2, maxRows: 10 }"
                  :readonly="textUpdate2En"
                  :disabled="item.id ? false : true"
                ></el-input>
                <el-button
                  :disabled="item.id ? false : true"
                  type="text"
                  :icon="textUpdate2En ? 'el-icon-edit' : 'el-icon-check'"
                  @click="updateText(2, 'En')"
                ></el-button>
                <!-- {{ textUpdate2En ? "编辑" : "完成" }} -->
              </div>
            </div>
            <div v-if="item.findings" v-for="(item, index) in item.findings" :key="index">
              <div class="o3 box" v-if="item.imgs.length == 0">
                <div class="o31 b1" style="text-align: left;">
                  发现{{ index + 1 }}
                </div>
                <div
                  class="textareaBox"
                  :class="item.textUpdate ? '' : 'boxBorder'"
                >
                  <el-input
                    type="textarea"
                    v-model="item.text"
                    :autosize="{ minRows: 2, maxRows: 10 }"
                    :readonly="item.textUpdate"
                  ></el-input>
                  <el-button
                    type="text"
                    :icon="item.textUpdate ? 'el-icon-edit' : 'el-icon-check'"
                    @click="updateText2(index, '')"
                  ></el-button>
                  <!-- {{ item.textUpdate ? "编辑" : "完成" }} -->
                </div>
                <div
                  class="textareaBox"
                  :class="item.textUpdateEn ? '' : 'boxBorder'"
                >
                  <el-input
                    type="textarea"
                    v-model="item.textEn"
                    :autosize="{ minRows: 2, maxRows: 10 }"
                    :readonly="item.textUpdateEn"
                  ></el-input>
                  <el-button
                    type="text"
                    :icon="item.textUpdateEn ? 'el-icon-edit' : 'el-icon-check'"
                    @click="updateText2(index, 'En')"
                  ></el-button>
                  <!-- {{ item.textUpdateEn ? "编辑" : "完成" }} -->
                </div>
              </div>
              <div class="o4 box" v-if="item.imgs.length == 1">
                <div class="o41 b1" style="text-align: left;">
                  发现{{ index + 1 }}
                </div>
                <div class="o42">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o421"
                    :class="item.textUpdate ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.text"
                      :autosize="{ minRows: 10, maxRows: 15 }"
                      :readonly="item.textUpdate"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="item.textUpdate ? 'el-icon-edit' : 'el-icon-check'"
                      @click="updateText2(index, '')"
                    ></el-button>
                    <!-- {{ item.textUpdate ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
              <div class="o4 box" v-if="item.imgs.length == 1">
                <div class="o41 b1" style="text-align: left;">
                  发现{{ index + 1 }}
                </div>
                <div class="o42">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o421"
                    :class="item.textUpdateEn ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.textEn"
                      :autosize="{ minRows: 10, maxRows: 15 }"
                      :readonly="item.textUpdateEn"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="
                        item.textUpdateEn ? 'el-icon-edit' : 'el-icon-check'
                      "
                      @click="updateText2(index, 'En')"
                    ></el-button>
                    <!-- {{ item.textUpdateEn ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
              <div class="o5 box" v-if="item.imgs.length == 2">
                <div class="b1" style="text-align: left;">
                  发现{{ index + 1 }}
                </div>
                <div class="o52">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <el-image
                    :src="item.imgs[1]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o521"
                    :class="item.textUpdate ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.text"
                      :autosize="{ minRows: 11, maxRows: 20 }"
                      :readonly="item.textUpdate"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="item.textUpdate ? 'el-icon-edit' : 'el-icon-check'"
                      @click="updateText2(index, '')"
                    ></el-button>
                    <!-- {{ item.textUpdate ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
              <div class="o5 box" v-if="item.imgs.length == 2">
                <div class="b1" style="text-align: left;">
                  发现{{ index + 1 }}
                </div>
                <div class="o52">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <el-image
                    :src="item.imgs[1]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o521"
                    :class="item.textUpdateEn ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.textEn"
                      :autosize="{ minRows: 11, maxRows: 20 }"
                      :readonly="item.textUpdateEn"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="
                        item.textUpdateEn ? 'el-icon-edit' : 'el-icon-check'
                      "
                      @click="updateText2(index, 'En')"
                    ></el-button>
                    <!-- {{ item.textUpdateEn ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
            </div>
            <div class="o6" v-if="pageType != 'demo'">
              <el-button
                @click="saveData(2)"
                class="btnClass11"
                :disabled="item.id ? false : true"
                style="background: linear-gradient(180deg, #FFFFFF 0%, #F9F9FB 100%);border: 1px solid #D7DCE4;"
                >导出报告</el-button
              >
              <el-button
                :disabled="item.id ? false : true"
                type="primary"
                @click="saveData(1)"
                style="background: linear-gradient(180deg, #16796F 0%, #045A51 100%);border: 1px solid #004B43;"
                >保存为报告</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="title">历史报告</div> -->
    <div style="" class="title2">
      {{ pageType == "demo" ? "测试样例" : "历史报告" }}
    </div>
    <div class="table">
      <el-table
        :data="tableList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="date" label="图片" width="280" align="center">
          <template slot-scope="scope">
            <div>
              <el-image
                style="width: 230px; height: 120px"
                :src="scope.row.image"
                :preview-src-list="[scope.row.image]"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="图片类别" align="center">
          <template slot-scope="scope">{{
            changeImageType(scope.row.picType)
          }}</template>
          <!-- scope.row.picType == 1 ? "CT" : "Other" -->
        </el-table-column>
        <el-table-column v-if="pageType != 'demo'" label="模型" align="center">
          <template slot-scope="scope">{{
            scope.row.model == 1 ? "CXR-Reportor" : "CXR-TMRGM"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="报告标题"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="gmtCreate"
          v-if="pageType != 'demo'"
          label="保存时间"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.gmtCreate | date1
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                v-if="pageType != 'demo'"
                class="detailClass"
                @click="jumpDetail(scope.row)"
                >查看详情</el-button
              >
              <el-button
                type="text"
                v-else
                class="detailClass"
                @click="use(scope.row)"
                >使用此样例</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        size="small"
        class="pagination"
        v-if="pageType != 'demo'"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      typeOptions: [
        { value: 1, label: "CT" },
        { value: 2, label: "X-ray" },
        { value: 3, label: "MRI" },
        { value: 4, label: "US" },
        { value: 5, label: "PET" },
        { value: 6, label: "Other" }
      ],
      page: 1,
      pageSize: 5,
      total: 0,
      //标签
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      //输出大图
      src: "",
      //表单
      form: {
        type: "",
        title: "",
        model: "1",
        img: ""
      },
      rules: {
        type: [
          { required: true, message: "请选择图片类别", trigger: "change" }
        ],
        title: [{ required: true, message: "请输入报告标题", trigger: "blur" }],
        model: [{ required: true, message: "请选择模型", trigger: "change" }]
      },
      // item: {
      //   dbId: 182,
      //   id: "cy0QFdpw9pUqPtyPhxmOjj3m",
      //   title: "16425755049438566",
      //   image:
      //     "https://imicams-images-store.oss-cn-beijing.aliyuncs.com/images/Md2E9uOd..jpg",
      //   overview: "",
      //   overviewEn: "",
      //   suggestion:
      //     "一只戴着墨镜和t恤的狮子在背景中是一个男人和一个女人的图像，在图片中看到狮子不是很清楚，但没有pneum",
      //   suggestionEn:
      //     "An image of a lion in the background of which is a man and a woman, in which the lion is seen in the picture is not very clear, but there is no pneum",
      //   findings: [
      //     {
      //       id: "",
      //       imgs: [],
      //       text: "",
      //       textEn: "",
      //       textUpdate: true,
      //       textUpdateEn: true
      //     }
      //   ],
      //   tagsStr: []
      // },
      item: {},
      textUpdate1: true,
      textUpdate2: true,
      textUpdate1En: true,
      textUpdate2En: true,
      tableList: [],
      fullscreenLoading: false,
      token: localStorage.getItem("token"),
      pageType: localStorage.getItem("pageType")
    };
  },
  filters: {
    date1(e) {
      let date = new Date(e);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    }
  },
  computed: {},
  components: {},
  methods: {
    use(e) {
      console.log(e);
      this.form = {
        type: e.picType,
        title: e.title,
        model: e.model + "",
        img: e.image
      };
      localStorage.setItem("form", JSON.stringify(this.form));
    },
    tableRowClassName({ row, rowIndex }) {
      return "success-row";
    },
    //检测图片类型
    changeImageType(e) {
      switch (e) {
        case 1:
          return "CT";
        case 2:
          return "X-ray";
        case 3:
          return "MRI";
        case 4:
          return "US";
        case 5:
          return "PET";
        case 6:
          return "Other";
        default:
          break;
      }
    },
    jumpDetail(e) {
      this.$router.push({
        path: "/detail",
        query: {
          id: e.id
        }
      });
    },
    // 保存报告
    saveData(e) {
      if (!this.item.overview) {
        this.$message({
          message: "请填写检查所见",
          type: "warning"
        });
        return;
      } else if (!this.item.suggestion) {
        this.$message({
          message: "请填写检查意见",
          type: "warning"
        });
        return;
      }
    //   for (let i in this.item.findings) {
    //     if (!this.item.findings[i].text) {
    //       this.$message({
    //         message: "请填写发现内容不因为空",
    //         type: "warning"
    //       });
    //       return;
    //     }
    //   }
      let params = {
        dbId: this.item.dbId,
        findings: this.item.findings,
        id: this.item.id,
        image: this.item.image,
        overview: this.item.overview,
        suggestion: this.item.suggestion,
        tagsStr: this.item.tagsStr.toString()
      };
      if (e == 1) {
        this.$axios.post("/medicine/save", params).then(res => {
          if (res.data.code == 0) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
            this.removeData();
            this.item = {};
            this.getData();
          }
        });
      } else {
        this.$axios.post("/medicine/export", params).then(res => {
          if (res.data.code == 0) {
            this.item = {};
            this.$message({
              message: "提交成功",
              type: "success"
            });
            window.open(res.data.data);
          }
        });
      }
    },
    updateText(e, index) {
      let that = this;
      if (e == 1) {
        this[`textUpdate1${index}`] = !this[`textUpdate1${index}`];
        if (this[`textUpdate1${index}`] && index == "") {
          let params = {
            text: this.item[`overview${index}`],
            type: index == "En" ? 2 : 1
          };
          this.$axios
            .get("/medicine/translateGeneral", { params })
            .then(res => {
              console.log("这里", `overview${index == "En" ? "" : "En"}`);
              that.item[`overview${index == "En" ? "" : "En"}`] = res.data.data;
              console.log("这里", that.item);
              that.$forceUpdate();
            });
        }
      } else {
        this[`textUpdate2${index}`] = !this[`textUpdate2${index}`];
        if (this[`textUpdate2${index}`] && index == "") {
          let params = {
            text: this.item[`suggestion${index}`],
            type: index == "En" ? 2 : 1
          };
          this.$axios
            .get("/medicine/translateGeneral", { params })
            .then(res => {
              that.item[`suggestion${index == "En" ? "" : "En"}`] =
                res.data.data;
              that.$forceUpdate();
            });
        }
      }
    },
    updateText2(e, index) {
      let item = this.item.findings[e];
      item[`textUpdate${index}`] = !item[`textUpdate${index}`];
      if (item[`textUpdate${index}`] && index == "") {
        let params = {
          text: item[`text${index}`],
          type: index == "En" ? 2 : 1
        };
        this.$axios.get("/medicine/translateGeneral", { params }).then(res => {
          item[`text${index == "En" ? "" : "En"}`] = res.data.data;
        });
      }
      this.$set(this.item.findings, e, item);
    },
    //提交报告
    submit(formName) {
    //   if (!this.token && pageType == "demo") {
    //     this.$emit("showLogin");
    //     return;
    //   }
      if (!this.form.img) {
        this.$message({
          message: "请上传图片",
          type: "warning"
        });
        return;
      }
      this.$refs[formName].validate(valid => {
        const loading = this.$loading({
          lock: true,
          text: "正在识别，请稍候...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        if (valid) {
          let params = {
            category: this.form.type,
            image: this.form.img,
            model: this.form.model,
            title: this.form.title
          };
          this.$axios.post("/medicine/submit", params).then(res => {
            loading.close();
            if (res.data.code == 0) {
              this.item = res.data.data;
              this.$axios
                .get("/medicine/translateGeneral", {
                  params: { text: this.item.overview, type: 1 }
                })
                .then(res => {
                  this.item.overviewEn = res.data.data;
                });
              this.$axios
                .get("/medicine/translateGeneral", {
                  params: { text: this.item.suggestion, type: 1 }
                })
                .then(res => {
                  this.item.suggestionEn = res.data.data;
                });
              for (let i in this.item.findings) {
                this.item.findings[i].textUpdate = true;
                this.item.findings[i].textUpdateEn = true;
                this.$axios
                  .get("/medicine/translateGeneral", {
                    params: { text: this.item.findings[i].text, type: 1 }
                  })
                  .then(res => {
                    this.item.findings[i].textEn = res.data.data;
                  });
              }
              if (this.item.tagsStr) {
                this.item.tagsStr = this.item.tagsStr.split(",");
              } else {
                this.item.tagsStr = [];
              }

              this.$message({
                message: "提交成功",
                type: "success"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    removeData() {
      this.form.img = "";
      this.form.model = "";
      this.form.type = "";
      this.form.title = "";
      this.item = {};
    },
    //表单文件上传
    async httpRequest(item) {
      let formData = new FormData();
      formData.append("file", item.file);
      console.log(item.file.name);
      this.form.title = item.file.name.split(".")[0];
      this.$axios.post("/medicine/file", formData).then(res => {
        if (res.data.code == 0) {
          this.form.img = res.data.data;
        }
      });
    },
    beforeAvatarUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      const whiteList = ["jpg", "png", "jpeg", "JPG", "PNG", "JPEG"];
      // console.log(whiteList.indexOf(fileSuffix) === -1)
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error("上传文件只能是 jpg、png、jpeg格式");
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 2MB");
        return false;
      }
    },
    // 标签
    handleClose(tag) {
      this.item.tagsStr.splice(this.item.tagsStr.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.item.tagsStr.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    getData() {
      let params = {
        pageNum: this.page,
        pageSize: this.pageSize
      };
      this.$axios.post("/medicine/page", params).then(res => {
        if (res.data.code == 0) {
          this.tableList = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    }
  },

  mounted() {
    console.log("1231231");

    if (
      !localStorage.getItem("token") &&
      localStorage.getItem("pageType") != "demo"
    ) {
      return;
    }
    if (localStorage.getItem("form")) {
      this.form = JSON.parse(localStorage.getItem("form"));
      localStorage.setItem("form", "");
    }
    this.getData();
  }
};
</script>
<style scoped>
@import "../../assets/allCss.scss";
/deep/ .el-table th.el-table__cell.is-leaf {
  /* border: 1px solid #d7dce4; */
  border-color: #d7dce4;
}
/deep/ .el-table .success-row {
  background: rgb(215, 220, 228, 0.4);
}
/deep/ .el-table th.el-table__cell > .cell {
  color: #004b43;
}
/deep/ .el-pager li.active {
  color: #004b43;
  font-weight: 900;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #3f3f3f;
}
/deep/ .el-form-item__label {
  color: #3f455d;
  font-size: 14px;
}
/deep/ .el-textarea .el-textarea__inner {
  padding: 5px 20px 5px 15px !important;
  box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.08);
}
/deep/ .el-textarea .el-textarea__inner:focus {
  border: 1px solid #045a51;
}
.top-desc {
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  color: #3f3f3f;
  margin-bottom: 20px;
  text-align: center;
  font-family: PingFang;
}
.top-title {
  font-style: normal;
  font-weight: 900;
  font-size: 28px;
  text-align: center;
  color: #3f3f3f;
  margin-top: 5px;
}
/deep/.el-select .el-input__inner {
  background: linear-gradient(180deg, #ffffff 0%, #f9f9fb 100%) !important;
  background: red;
}
.detailClass {
  cursor: pointer;
  color: #004b43;
}
.baiduQueue {
  background: #fff;
}
.title2 {
  margin-left: 44px;
  font-weight: 900;
  font-size: 16px;
  color: #3f3f3f;
  margin-top: 32px;
}
.table {
  width: calc(100% - 80px);
  margin: 12px auto;
  background: #ffffff;
  border: 1px solid #dee3ec;
  border-radius: 12px;
  padding-top: 5px;
}
.pagination {
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
.output {
  border: 1px solid #dee3ec;
  border-radius: 8px;
}
.o1 {
  border-bottom: 1px solid #dee3ec;
}
.o1 .el-image {
  width: 1024px;
  height: 506px;
  display: block;
  border-radius: 12px;
  margin: 0 auto 20px;
}
.o1 div {
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 18px;
  color: #3f455d;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 20px;
}
.o2 {
  height: 100px;
  padding: 20px 40px 0;
}
.o2 .o22 {
  width: calc(100% - 80px);
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.o3 {
}
.o4 {
}
.o42 {
  display: flex;
  justify-content: space-between;
}
.o42 .el-image {
  width: 374px;
  height: 246px;
  display: block;
  border-radius: 12px;
}
.o42 .o421 {
  width: 65%;
}
.o5 .o52 {
  display: flex;
  justify-content: space-between;
}

.o5 .o52 .el-image {
  width: 374px;
  height: 246px;
  display: block;
  border-radius: 12px;
}
.o5 .o52 .o521 {
  width: 35%;
}

.o6 {
  padding: 50px 20px;
  display: flex;
  justify-content: center;
}
.o6 .el-button {
  width: 50%;
}
.formClass {
  width: calc(100% - 80px);
  margin: 12px auto;
  background: #ffffff;
  /* border: 1px solid #dee3ec; */
  border-radius: 12px;
}
.formClass .f2 .form_right {
  /* width: 40%; */
  border: 1px solid #dee3ec;
  border-radius: 10px;
  padding: 10px;
  margin-top: 16px;
}
/deep/ .formClass .f2 .form_right .el-form-item__label {
  float: none;
}
/deep/ .formClass .f2 .upload-demo .el-upload-dragger .el-icon-upload {
  width: 64px;
  height: 64px;
  margin: 0 auto 15px;
}
/deep/ .formClass .f2 .upload-demo .el-upload-dragger .el-upload__text {
  font-family: "PingFang SC";
  font-weight: 400;
  width: 100%;
  color: #9ba1aa;
  margin: 0 auto;
}
/deep/ .formClass .f2 .upload-demo .el-upload-dragger .showImg {
  width: 100%;
  height: 100%;
  border-radius: 12px;
}
/deep/ .formClass .f2 .upload-demo .el-upload {
  width: 100%;
}
/deep/ .formClass .f2 .upload-demo .el-upload-dragger {
  width: 100%;
  height: 362px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background: #f8f8fa; */
  border: 1px dashed #d7dce4;
  border-radius: 8px;
}
.formClass .f2 {
  /* display: flex;
  justify-content: space-between; */
  /* width: calc(100% - 64px); */
  /* padding: 32px 0 32px 32px; */
  /* margin: 12px 0 12px 0; */
  /* width: 100%; */

  padding: 12px;
  background: #f7f8fa;
  border-radius: 12px;
  width: 50%;
}
.formClass .f2 .el-button {
  width: 215px;
}
.textareaBox {
  position: relative;
  width: 100%;
  height: auto;
  /* background-color: #fff; */
  /* border: 1px solid #dcdfe6; */
  resize: vertical;
  border-radius: 4px;
  margin-bottom: 10px;
}
/deep/ .textareaBox .el-textarea {
  /* width: calc(100% - 56px); */
}

.textareaBox .el-textarea textarea {
  border: 1px solid transparent;
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 14px;
  color: #3f3f3f;
}
.textareaBox .el-button {
  position: absolute;
  right: 6px;
}
.box {
  height: auto;
  /* width: calc(100% - 80px); */
  padding: 20px 12px;
  border-bottom: 1px solid #dee3ec;
}
.box .b1 {
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 14px;
  color: #3f455d;
  margin-bottom: 12px;
}
.title {
  width: calc(100% - 20px);
  height: 60px;
  border-radius: 12px 12px 0 0;
  background: #f8f8fa;
  border-bottom: 1px solid #dee3ec;
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 17px;
  color: #3f3f3f;
  line-height: 60px;
  padding-left: 20px;
}
.boxBorder {
  /* border: 1px solid #29bccf; */
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  background: #29bccf;
  border: 1px solid #29bccf;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue